import React from "react";
import IconSvgComponent from "components/svg-icon/svg-icon";
import classNames from "classnames";

const Heading = ({ icon, text, alt, scaleIcons, extraClass, style }) => {
  return (
    <div
      style={style}
      className={classNames(
        "heading",
        { "heading--alt": alt, "heading--scaled-icon": scaleIcons },
        extraClass
      )}
    >
      <div className="heading__icon">
        <IconSvgComponent icon={icon} />
      </div>
      {text}
    </div>
  );
};

export default Heading;
